import { action, observable, makeObservable, computed } from 'mobx';

import { PopupsStore, IPopupsStore } from '@gem/popups';

import { AudioSourceType } from 'APP/constants/app';
import { DEFAULT_ACCOUNT_COUNTRY } from 'APP/constants/countryCodes';
import { ICountry } from 'APP/types/countryCodes';

import packageJSON from '../../../package.json';
import { IAudioSource, TCloseFullscreenCallback, TPauseAudioSourceCallback } from './App.types';

export class App {
  version = packageJSON.version;
  isBackPage = false;
  @observable isFocused = true;
  @observable isOfflineNetworkStatus = false;
  @observable width: number | null = null;
  @observable height: number | null = null;
  @observable popups: IPopupsStore = PopupsStore;
  @observable currentAudioSources = observable.array<IAudioSource>([], { deep: false });
  @observable availableCountries: ICountry[] = [];
  accountCountry = DEFAULT_ACCOUNT_COUNTRY;
  whitelistHosts: string[] = [];
  fullscreenCloseCallback: TCloseFullscreenCallback | null = null;

  constructor() {
    makeObservable(this);
  }

  setWhitelistHosts(whitelistHosts: string[]): void {
    this.whitelistHosts = whitelistHosts;
  }

  @action
  reset(): void {
    this.isFocused = true;
    this.isOfflineNetworkStatus = false;
    this.width = null;
    this.height = null;
    this.currentAudioSources.clear();
    this.accountCountry = DEFAULT_ACCOUNT_COUNTRY;
    this.popups.reset();
  }

  @action
  setFocused = (isFocused: boolean): void => {
    this.isFocused = isFocused;
  };

  @action
  addLayer = (): void => {
    this.popups.addLayer();
  };

  @action
  removeLayer = (): void => {
    this.popups.removeLayer();
  };

  @action
  setOfflineNetworkStatus = (isOfflineNetworkStatus: boolean): void => {
    this.isOfflineNetworkStatus = isOfflineNetworkStatus;
  };

  @action
  setWidth(width: number | null): void {
    this.width = width;
  }

  @action
  setHeight(height: number | null): void {
    this.height = height;
  }

  @action
  addCurrentAudioSource(source: IAudioSource): void {
    this.currentAudioSources.push(source);
  }

  @action
  removeCurrentAudioSource(type: AudioSourceType, callback?: TPauseAudioSourceCallback): void {
    let list = this.currentAudioSources.slice();

    if (!callback) {
      list = list.filter((item: IAudioSource): boolean => item.type !== type);
    } else {
      list = list.filter(
        (item: IAudioSource): boolean => item.type !== type && item.callback !== callback
      );
    }

    this.currentAudioSources.replace(list);
  }

  @computed
  get uiLayer(): number {
    return this.popups.uiLayer;
  }

  setIsBackPage(isBack: boolean): void {
    this.isBackPage = isBack;
  }

  @action
  setAvailableCountries(countries: ICountry[]): void {
    this.availableCountries = countries;
  }

  setAccountCountry(accountCountry: ICountry): void {
    this.accountCountry = accountCountry;
  }
}
